export default __webpack_public_path__ + "static/media/wildlife10.57d1b3ef.png";